const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5181/api";

export async function signup({email, password, firstName, lastName}){
    const res = await fetch(`${BASE_URL}/auth/register`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({email, password, firstName, lastName}),
    });

const data = await res.json();

if(!res.ok){
    throw new Error(data.message || "Signup failed");
}

return data;
}

export async function login({email, password}){
    const res = await fetch(`${BASE_URL}/auth/login`,{
        method : "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({email, password}),
    });
    const data = await res.json();
    if(!res.ok){
        throw new Error(data.message || "Login Failed");
    }
    return data;

}


export async function getEvents() {
    const token = localStorage.getItem('token');
    const res = await fetch(`${BASE_URL}/events`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
    });
    const data = await res.json();
    if(!res.ok){
        throw new Error(data.message || "Failed to fetch Events");
    }
    return data;
}

export async function createEvent(eventData) {
    const token = localStorage.getItem('token');

    const res = await fetch(`${BASE_URL}/events`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(eventData),
    });

    const data = await res.json();

    if (!res.ok) {
        throw new Error(data.message || "Failed to create event");
    }

    return data;
}
